<template>
    <v-card class="panelBlock 111">
        <v-flex tag="h2" data-qe-id="ypo_networks_title">{{networkConstants.YPO_NETWORK}}</v-flex>
        <v-tabs
            color="ypo_blue"
            slider-color="ypo_gold"
            class="network__tabs__sub"
            v-model="currentTab">
            <v-tab
                v-for='(list,i) in networkTypes'
                :key="i"
                @click="getFilterYPONetworks(list)"
                :data-qe-id="`ypo_network-tab_${i}`">
                {{list}}
            </v-tab>
            <v-tab-item v-for='(list,i) in networkTypes' :key="i">
                <v-flex class="network__tabs__sub__list inner-scrollbar">
                    <v-flex v-for='(list,i) in ypoNetworksList' :key="i">
                      <a @click="navigateToNetwork(list.communityId)" :data-qe-id="`network-option_${i}`">
                          {{list.name}}
                      </a>
                    </v-flex>
                    <v-flex v-if="!ypoNetworksList.length" data-qe-id="no_network_exists">
                        {{'There are no '}} {{list}} {{' Networks'}}
                    </v-flex>
                </v-flex>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
    import { mapGetters } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { networkConstants } from "../ChapterPage/communityCommon.constant";
    import StatusOverlay from "../StatusOverlay/StatusOverlay";
    import { getHbRedirectByCommunityId } from "@/common/utils/hivebriteUtils";
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";

    export default {
        name: "YpoNetworks",
        components: {
            StatusOverlay,
        },
        created() {
            this.getFilterYPONetworks('All');
        },
        data: () => {
            return {
                currentTab: 0,
                ypoNetworksList: [],
                networkConstants,
            };
        },
        methods: {
            getFilterYPONetworks(value) {
                if (!this.ypoNetworks || !this.ypoNetworks.length) {
                    this.ypoNetworksList = [];
                } else if (value.toLowerCase() === networkConstants.ALL) {
                    this.ypoNetworksList = this.ypoNetworks;
                    this.currentTab = 0;
                } else if (value.toLowerCase() === networkConstants.IMPACT) {
                    this.ypoNetworksList = this.ypoNetworks.filter(o => o.communitySubType.toLowerCase() === networkConstants.IMPACT);
                } else {
                    this.ypoNetworksList = this.ypoNetworks.filter(o => o.communitySubType.toLowerCase() === value.toLowerCase()); 
                }
            },
          navigateToNetwork(communityId) {
            const hbRedirectCommunity = getHbRedirectByCommunityId(this.connectPlusRedirects, communityId);
            if (hbRedirectCommunity) {
              const target = this.isMobileAppBrowser ? '_self' : '_blank';
              window.open(hbRedirectCommunity.redirectUrl, target);
            } else {
              this.$router.push(`/network/${communityId}`);
            }
            gaDataLayerEvent(gtmEventName.C_Network_Page_Selected_Network, communityId);
          },
        },
        computed: {
            ...mapGetters({
                ypoNetworks: `network/${storeGetters.ypoNetworks}`,
                connectPlusRedirects: `connectPlus/${storeGetters.connectPlusRedirects}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            networkTypes() {
                if (!this.ypoNetworks || !this.ypoNetworks.length) return [];

                return networkConstants.YPO_NETWORK_TYPES.filter(type => {
                if (type === 'ALL') return true;
                return this.ypoNetworks.some(n => n.communitySubType.toLowerCase() === type.toLowerCase());
                });            
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";

    .network__tabs__sub {
        .v-tabs__item {
            color: $white;
            text-transform: initial;
        }

        .v-tabs__icon {
            color: $white;
        }

        &__list {
            min-height: 250px;
            overflow-y: auto;
            max-height: 250px;
            padding: 15px 20px;

            .flex {
                margin-bottom: 10px;
            }

            a {
                text-decoration: none;
                transition: 0.3s all ease;
                color: $ypo-cta;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
</style>
